import { createMemoryHistory, type Location } from "history";
import { useState } from "react";
import { type match } from "react-router";

import { BTLayoutContent } from "commonComponents/btWrappers/BTLayout/BTLayout";
import { BTModal } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTModalLayoutBDS } from "commonComponents/btWrappers/BTModalBDS/BTModalLayoutBDS";

import SelectionOption from "entity/selectionOptions/SelectionOption/SelectionOption";
import {
    type ISelectionOptionLocationState,
    type SelectionOptionStateOverride,
} from "entity/selectionOptions/SelectionOption/SelectionOption.types";

import { SelectionOptionModalHeaderSlotContext } from "./SelectionOptionModalHeaderSlotContext";

export interface ISelectionOptionModalProps {
    jobId: number;
    selectionOptionId?: number;
    isVisible: boolean;
    stateOverride?: SelectionOptionStateOverride;
    onClose: () => void;
    /** When true, the detail opens with the Comments panel expanded (from the list's comment icon). */
    openComments?: boolean;
}

export function SelectionOptionModal(props: Readonly<ISelectionOptionModalProps>) {
    const { jobId, selectionOptionId, isVisible, onClose, openComments = false } = props;
    const [headerSlot, setHeaderSlot] = useState<HTMLDivElement | null>(null);
    const history = createMemoryHistory();
    const [shouldOpenComments] = useState(openComments);
    const location: Location = {
        pathname: "/",
        search: "",
        state: shouldOpenComments
            ? ({ openComments: true } satisfies ISelectionOptionLocationState)
            : null,
        hash: "",
        key: "default",
    };
    const match: match = {
        params: {},
        isExact: true,
        path: "",
        url: "",
    };

    return (
        <BTModal
            data-testid="selectionOptionModal"
            title=""
            setPageTitle={false}
            width="1500px"
            beforeClose={onClose}
            visible={isVisible}
            useModalLayout
            removeBodyPadding
        >
            <BTModalLayoutBDS
                useBDSLayout
                useBDSLayoutContentPadding={false}
                modalConfig={{ parentRoute: "", beforeClose: onClose }}
                header={
                    <div
                        ref={setHeaderSlot}
                        data-testid="selectionOptionModalHeaderSlot"
                        style={{ width: "100%" }}
                    />
                }
            >
                <SelectionOptionModalHeaderSlotContext.Provider value={headerSlot}>
                    <BTLayoutContent>
                        <SelectionOption
                            jobId={jobId}
                            entity={{
                                selectionOptionLineItems: [],
                                lineItemDefaults: { keysThatBreakCostLink: [] },
                                selectionOptionGroups: [],
                            }}
                            selectionOptionId={selectionOptionId}
                            isModal
                            // these are unused due to the props but required for the component
                            history={history}
                            location={location}
                            match={match}
                            onModalClose={onClose}
                            stateOverride="View"
                        />
                    </BTLayoutContent>
                </SelectionOptionModalHeaderSlotContext.Provider>
            </BTModalLayoutBDS>
        </BTModal>
    );
}

export default SelectionOptionModal;
